/**
 * Panel colapsable de un requerimiento. **Componente propio.**
 *
 * Construido sobre `<details>/<summary>`, no sobre Radix: es accesible de
 * serie —teclado, lector de pantalla, `Ctrl+F` del navegador encuentra el
 * contenido colapsado— y no añade una dependencia por un patrón que el
 * navegador ya resuelve. Ver SISTEMA_DISENO.md §3.2.
 *
 * Los requerimientos anteriores quedan colapsados pero presentes: son parte de
 * la traza, no ruido que se pueda esconder.
 */
import type { ReactNode } from 'react'
import { StatusBadge } from '@mpfn/ui'
import { ChevronRight } from 'lucide-react'
import type { Tono } from '../api/tipos.js'
import { fecha } from '../lib/formato.js'

interface PropsAcordeon {
  ordinal: number
  /** «Oficio N.° 002017-2026-…», el provisional mientras no vuelva firmado, o «Consulta en línea». */
  referencia: string
  fechaEmision: string
  estadoEtiqueta: string
  tono: Tono
  /** Abierto por defecto el vigente; los anteriores, colapsados. */
  abiertoPorDefecto?: boolean
  anulada?: boolean
  children: ReactNode
}

export function AcordeonRequerimiento({
  ordinal,
  referencia,
  fechaEmision,
  estadoEtiqueta,
  tono,
  abiertoPorDefecto = false,
  anulada = false,
  children,
}: PropsAcordeon) {
  return (
    <details className="mpfn-acordeon" data-anulada={anulada ? 'si' : 'no'} open={abiertoPorDefecto}>
      <summary className="mpfn-acordeon__cabecera mpfn-control">
        <ChevronRight className="mpfn-acordeon__flecha" size={16} aria-hidden="true" />
        <span className="mpfn-acordeon__titulo">
          Requerimiento {ordinal}
          <span className="mpfn-acordeon__detalle">
            {' · '}
            {referencia} · {fecha(fechaEmision)}
          </span>
        </span>
        <StatusBadge tone={anulada ? 'neutral' : tono} label={anulada ? 'Anulado' : estadoEtiqueta} />
      </summary>
      <div className="mpfn-acordeon__cuerpo">{children}</div>
    </details>
  )
}
